import React, { useState } from 'react';
import { motion } from 'framer-motion';
import Header from '../../components/Header';
import LogsTable from '../../components/LogsTable';

const LogsPage: React.FC = () => {
  const [error, setError] = useState<string | null>(null);

  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      <Header />

      <main className="flex-grow container mx-auto px-4 py-8">
        <div className="max-w-7xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            className="mb-6"
          >
            <h1 className="text-2xl font-bold text-gappex-dark">
              Logs de Auditoría
            </h1>
            <p className="text-gray-600 mt-1">
              Registro de todas las consultas de suscriptores realizadas en el sistema.
            </p>
          </motion.div>

          {error && (
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              className="bg-red-100 border-l-4 border-red-500 p-4 my-6 rounded"
            >
              <div className="flex">
                <svg className="w-6 h-6 text-red-500 mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                <div>
                  <p className="font-medium text-red-800">Error</p>
                  <p className="text-red-700">{error}</p>
                </div>
              </div>
            </motion.div>
          )}

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.1 }}
            className="bg-white rounded-lg shadow-md p-6"
          >
            <LogsTable onError={setError} />
          </motion.div>
        </div>
      </main>

      <footer className="bg-gappex-dark text-white py-6 mt-auto">
        <div className="container mx-auto px-4 text-center">
          <p className="mb-0">© {new Date().getFullYear()} Gappex - Validación de Suscriptores</p>
        </div>
      </footer>
    </div>
  );
};

export default LogsPage;
